import { displayError, displayWarning } from "../../utils/messageToast";
import { displaySuccess } from "../../utils/messageToast";
import { arrayCSV } from "../../utils/functionsInterfaces";
import { SetupFlowRC } from "../../apis/apisFlowRCByAuthorizationRA_Authorization";

export const toRespondTickets = async (
  ambient: string,
  authorization: string,
  updatedProtocolData: arrayCSV[],
  setCsvData: React.Dispatch<React.SetStateAction<any[]>>,
  setIsErrors: React.Dispatch<React.SetStateAction<boolean>>,
  setErrors: React.Dispatch<React.SetStateAction<any[]>>,
  signOut: () => void
) => {
  const authorizationRA = "";
  try {
    const apiClient = SetupFlowRC(authorizationRA, authorization);
    const response = await apiClient.post(
      `/respond-pendency-ticket?ambient=${ambient}`,
      updatedProtocolData
    );

    if (response.data.errors.length > 0) {
      displayWarning("Alguns tickets não foram respondidos!");
      setIsErrors(true);
      setErrors(response.data.errors);

      setCsvData([]);
      return;
    } else {
      displaySuccess("Tickets respondidos com sucesso!");
      setIsErrors(false);
      setErrors([]);

      setCsvData([]);
    }
  } catch (error: any) {
    displayError("Erro ao responder tickets!");
    return;
  }
};
